import { useThreadComposerLayout } from "./threadComposerLayoutContext";
import { type ComponentProps, type ReactElement } from "react";
import { ChevronDownIcon } from "lucide-react";
import { MessagesTimeline } from "./MessagesTimeline";

type MessagesTimelineProps = ComponentProps<typeof MessagesTimeline>;

export function ChatTimelinePanel(props: {
  readonly timelineKey: string;
  readonly timelineProps: MessagesTimelineProps;
  readonly showScrollToBottom: boolean;
  readonly onScrollToBottom: () => void;
}): ReactElement {
  const { overlayHeight } = useThreadComposerLayout();
  return (
    <div className="relative flex min-h-0 flex-1 flex-col">
      <MessagesTimeline key={props.timelineKey} {...props.timelineProps} />

      {props.showScrollToBottom ? (
        <div
          style={{ bottom: overlayHeight + 4 }}
          className="pointer-events-none absolute bottom-1 left-1/2 z-30 flex -translate-x-1/2 justify-center py-1.5"
        >
          <button
            type="button"
            onClick={props.onScrollToBottom}
            className="pointer-events-auto flex items-center gap-1.5 rounded-full border border-border/60 bg-card px-3 py-1 text-muted-foreground text-xs shadow-sm transition-colors hover:border-border hover:text-foreground hover:cursor-pointer"
          >
            <ChevronDownIcon className="size-3.5" />
            Scroll to bottom
          </button>
        </div>
      ) : null}
    </div>
  );
}
